
import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { Truck } from 'lucide-react';

import toast from 'react-hot-toast';

import api from '../api';

export default function Login() {

  const [form, setForm] = useState({ email: '', password: '' });
  const [companyName, setCompanyName] = useState('');
  useEffect(() => {
    fetch('/platform/admin/whoami')
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && d.name) { setCompanyName(d.name); document.title = d.name + ' — Delivery Portal'; } })
      .catch(() => {});
  }, []);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const submit = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      const { data } = await api.post('/auth/login', form);

      localStorage.setItem('token', data.token);

      localStorage.setItem('user', JSON.stringify(data.user));

      navigate('/');

    } catch {

      toast.error('Invalid email or password');

    } finally { setLoading(false); }

  };

  return (

    <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

      <div style={{ background: '#1e293b', borderRadius: 16, padding: 40, width: 360, boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>

        <div style={{ textAlign: 'center', marginBottom: 32 }}>

          <Truck size={40} color="#38bdf8" style={{ marginBottom: 12 }} />

          <h1 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 700, margin: 0 }}>{companyName || 'Delivery Portal'}</h1>

          <p style={{ color: '#64748b', fontSize: 13, marginTop: 6 }}>Delivery management</p>

        </div>

        <form onSubmit={submit}>

          <div style={{ marginBottom: 16 }}>

            <label style={{ color: '#94a3b8', fontSize: 12, display: 'block', marginBottom: 6 }}>Email</label>

            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})}

              placeholder="you@company.com" required

              style={{ width: '100%', padding: '10px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#f1f5f9', fontSize: 14, boxSizing: 'border-box' }} />

          </div>

          <div style={{ marginBottom: 24 }}>

            <label style={{ color: '#94a3b8', fontSize: 12, display: 'block', marginBottom: 6 }}>Password</label>

            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})}

              placeholder="••••••••" required

              style={{ width: '100%', padding: '10px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#f1f5f9', fontSize: 14, boxSizing: 'border-box' }} />

          </div>

          <button type="submit" disabled={loading}

            style={{ width: '100%', padding: '11px', background: '#0284c7', border: 'none', borderRadius: 8, color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>

            {loading ? 'Signing in...' : 'Sign in'}

          </button>

        </form>



      </div>

    </div>

  );

}

